import React, { useState, useContext, useEffect } from "react"
import Leaflet from "leaflet"
import { Map, TileLayer, Marker } from "react-leaflet"
import "./map.css"
import "../../../../../node_modules/leaflet/dist/leaflet.css"
import { useTranslation } from "react-i18next"

// Set default icon URLs for Leaflet markers
Leaflet.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
})

const employees = [
  {
    id: 1,
    name: "ahmed mohamed ibrahim",
    jopTitle: "UI-UX",
    punchIn: "9:00 AM",
    punchOut: "12:00 PM",
    locationType: "destination",
    phone: "012345678912",
    coordinates: {
      lat: 40.7128, // New York, USA
      lng: -74.006,
    },
    avatar: require("../../../../assets/images/users/avatar-1.jpg"),
  },
  {
    id: 2,
    name: "ali mahmoud ahmed",
    jopTitle: "Front-End",
    punchIn: "9:00 AM",
    punchOut: null,
    locationType: "office",
    phone: "012345678912",
    coordinates: {
      lat: 48.8566, // Paris, France (Europe)
      lng: 2.3522,
    },
    avatar: require("../../../../assets/images/users/avatar-2.jpg"),
  },
  {
    id: 3,
    name: "shref mahmoud ali",
    jopTitle: "Back-End",
    punchIn: null,
    punchOut: null,
    locationType: null,
    phone: "012345678912",
    coordinates: {
      lat: 30.0444, // Cairo, Egypt (Africa)
      lng: 31.2357,
    },
    avatar: require("../../../../assets/images/users/avatar-3.jpg"),
  },
  {
    id: 4,
    name: "yassen mahmoud ahmed",
    jopTitle: "Mobile",
    punchIn: "9:00 AM",
    punchOut: null,
    locationType: "destination",
    phone: "012345678912",
    coordinates: {
      lat: 35.6895, // Tokyo, Japan (Asia)
      lng: 139.6917,
    },
    avatar: require("../../../../assets/images/users/avatar-4.jpg"),
  },
  {
    id: 5,
    name: "essam mahmoud ahmed",
    jopTitle: "Full-Stack",
    punchIn: "9:00 AM",
    punchOut: null,
    locationType: "destination",
    phone: "012345678912",
    coordinates: {
      lat: -33.8688, // Sydney, Australia
      lng: 151.2093,
    },
    avatar: require("../../../../assets/images/users/avatar-5.jpg"),
  },
  {
    id: 6,
    name: "hassan mahmoud ahmed",
    jopTitle: "DevOps",
    punchIn: "9:00 AM",
    punchOut: null,
    locationType: "destination",
    phone: "012345678912",
    coordinates: {
      lat: -23.5505, // São Paulo, Brazil (South America)
      lng: -46.6333,
    },
    avatar: require("../../../../assets/images/users/avatar-6.jpg"),
  },
]

export const TrackDelivery = () => {
  const [state, setState] = useState({
    lat: 51.505,
    lng: -0.09,
    zoom: 2,
  })

  const { i18n } = useTranslation()

  const position: [number, number] = [state.lat, state.lng]

  return (
    <div className="d-flex flex-column gap-4">
      <h4 className="font-size-16 text-capitalize fw-semibold">
        {i18n.t("dashboard_trackDelivery")}
      </h4>

      <Map
        center={position}
        zoom={state.zoom}
        style={{ height: "73vh", borderRadius: "16px" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {employees
          ? employees.map((employee, index) => (
              <Marker
                key={index}
                // onClick={() => changeSelectedEmployeeId(employee.id)}
                position={[employee.coordinates.lat, employee.coordinates.lng]}
                icon={
                  new Leaflet.Icon({
                    iconUrl: employee.avatar,
                    iconSize: [32, 32],
                    iconAnchor: [16, 32],
                    popupAnchor: [0, -32],
                    className: "map_image",
                  })
                }
              />
            ))
          : null}
      </Map>
    </div>
  )
}
